export const FileType = {
    ALL: "*",
    PDF: "application/pdf",
    IMAGES: "image/*",
    OOXML: ".xlsx",
}